import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Gjoba } from "../models/SearchService/gjoba.model";

@Injectable({
  providedIn: "root"
})
export class GjobaHttpClientService {
  private readonly base = environment.backendBaseUrl;
  private readonly endpoint = "/api/gjoba";
  private readonly fullPath = `${this.base}${this.endpoint}`;
  private readonly searchURL = `${this.fullPath}/search`;
  private readonly CCURL = `${this.fullPath}/start-cc`;
  private readonly walletURL = `${this.fullPath}/payment/web`;

  constructor(private http: HttpClient) {}

  Search(targa: string) {
    const params = new HttpParams().set("plate", targa);

    return this.http.get<Gjoba[]>(this.searchURL, {
      params
    });
  }

  PayCC(invoice: any) {
    return this.http.post<any>(`${this.CCURL}`, invoice);
  }

  PayWallet(invoice: any) {
    return this.http.post<any>(`${this.walletURL}`, invoice);
  }
}
